import axios from "axios";

export default axios.create({
  baseURL: `https://oktacron-server.webox.rs`,
});
